<template>
  <span class="fileLanguages d-block mb-1" v-if="dataFormat.length !== 0">
    <flag
      :squared="false"
      v-for="flag in dataFormat"
      :iso="fileIcon(flag)"
      :key="flag"
    />
  </span>
</template>

<script>
export default {
  name: 'icon-languages',
  props: {
    data: {
      type: Array
    }
  },
  computed: {
    dataFormat () {
      return this.data.map(v => ["EN", "en"].includes(v) ? 'gb' : v.toLowerCase())
    }
  },
  methods: {
    fileIcon (flag) {
      return (flag === "ar") ? 'eh' : flag
    }
  }
}
</script>
<style scoped>
.fileLanguages {
  font-size: 125%;
}
.fileLanguages > span {
  margin-right: .25rem;
}
</style>
